import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_COMPETITIONTABLE,
  SET_COMPETITIONTABLE,
  SET_ERROR,
  getKey,
} from "./constants";

const initialState = {
  isReady: {},
  isError: {},
  table: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPETITIONTABLE:
      return {
        ...state,
        isReady: {
          ...state.isReady,
          [action.key]: true,
        },
        isError: {
          ...state.isError,
          [action.key]: false,
        },
        table: {
          ...state.table,
          [action.key]: action.data.table,
        },
      };
    case RESET_COMPETITIONTABLE:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: {
          ...state.isReady,
          [action.key]: false,
        },
        isError: {
          ...state.isError,
          [action.key]: true,
        },
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

const selectIsReady = (state, props) => getState(state).isReady[getKey(props)];

export const makeSelectIsReady = () => createSelector(selectIsReady, (n) => n);

const selectIsError = (state, props) => getState(state).isError[getKey(props)];

export const makeSelectIsError = () => createSelector(selectIsError, (n) => n);

const selectCompetitionTable = (state, props) => {
  return getState(state).table[getKey(props)];
};

export const makeSelectCompetitionTable = () =>
  createSelector(selectCompetitionTable, (n) => n);

reducerRegistry.register(REDUCER_NAME, reducer);
